import React from "react"


let myContext=React.createContext()
let LoginContext = React.createContext({});


export {LoginContext,myContext} 